import { render, staticRenderFns } from "./newExchangeManagement.vue?vue&type=template&id=1f5b55ac&"
import script from "./newExchangeManagement.vue?vue&type=script&lang=js&"
export * from "./newExchangeManagement.vue?vue&type=script&lang=js&"
import style0 from "./newExchangeManagement.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports